import U from '@/lib/vendor/eve/lib-utils';

const MATCHED_HTML_KEY = 'lib-translator:hide-matched-html';
export default{
    methods: {
        getFullTermParentPrefix: function () {
            return null;
        },
        getFTPrefix: function () {
            let ftp = this.getFullTermParentPrefix();
            if (null !== ftp) {
                return [ftp, this.$options.name].join(':');
            }
            return this.$options.name;
        },
        getText: function (term) {
            let prefix = this.getFTPrefix();
            let full_term = [prefix, term].join(':');
            let translation = this.TT(full_term);
            if (null !== translation) {
                let lct = translation.toLowerCase();
                if ('--none--' !== lct && '--empty--' !== lct) {
                    return translation;
                }
            }
            return null;
        },
        getTextSafe: function (term) {
            return U.NEString(this.getText(term), '');
        },
        hasText: function (term) {
            return null !== this.getText(term);
        },
        substText: function (template, replacements) {
            let tpl = U.NEString(template, null);
            if (null !== tpl) {
                if (U.isObject(replacements)) {
                    for (let k in replacements) {
                        if (Object.prototype.hasOwnProperty.call(replacements, k)) {
                            if (!U.isCallable(replacements[k]) && !U.isArray(replacements[k]) && !U.isObject(replacements[k])) {
                                try {
                                    let regexp = new RegExp(['%', k, '%'].join(''), 'ig');
                                    tpl = tpl.replace(regexp, replacements[k]);
                                } catch (error) {
                                    // do nothing
                                }

                            }
                        }
                    }
                }
                return tpl;
            }
            return template;
        },
        getSubstText: function (term, replacements) {
            return this.substText(this.getText(term), replacements);
        },
        getHTML: function (term) {
            let prefix = this.getFTPrefix();
            let fTerm = [prefix, term].join(':');
            let hTerm = ['--html--', fTerm].join(':');
            let T = this.TT(hTerm);
            if (T === hTerm) {
                if (U.anyBool(localStorage.getItem(MATCHED_HTML_KEY), true)) {
                    T = null;
                }
            }
            if (null !== T) {
                let lowT = T.toLowerCase();
                if ('--none--' !== lowT && '--empty--' !== lowT) {
                    return T;
                }
            }
            return null;
        },
        getHTMLSafe: function (term) {
            return U.NEString(this.getHTML(term), '');
        },
        hasHTML: function (term) {
            return null !== this.getHTML(term); 
        }
    }
}